module.exports = __webpack_public_path__ + "static/media/illustration_contact-characters.864e3018.svg";